import { audioMessage as message } from '../../Components/Common/Notifications/audioMessage';
import { trainingAPI } from "../../api/TrainingAPI";

export const SETTINGS_SET_LOADING = "[SETTINGS]_SET_SET_LOADING";
export const SETTINGS_SET_DATAPOINT_PENDING =
  "[SETTINGS]_SET_SET_DATAPOINT_PENDING";
export const SETTINGS_SET_DATAPOINT = "[SETTINGS]_SET_DATAPOINT";
export const SETTINGS_SET_AVG_DATAPOINT = "[SETTINGS]_SET_AVG_DATAPOINT";
export const SETTINGS_SET_MODIFIED_VALUES = "[SETTINGS]_SET_MODIFIED_VALUES";
export const SETTINGS_SET_RESPONSE = "[SETTINGS]_SET_RESPONSE";
export const SETTINGS_SET_BULLETS = "[SETTINGS]_SET_BULLETS";

export const SETTINGS_SET_AUTOMATIC_ACTIONS =
  "[SETTINGS]_SET_AUTOMATIC_ACTIONS";

export const SETTINGS_SET_DATAPOINT_ERROR =
  "[SETTINGS]_SET_SET_DATAPOINT_ERROR";

export const setSettingsLoading = (data) => {
  return {
    type: SETTINGS_SET_LOADING,
    data,
  };
};

export const setDatapointPending = (data) => {
  return {
    type: SETTINGS_SET_DATAPOINT_PENDING,
    data,
  };
};

export const setBullets = (data) => {
  return {
    type: SETTINGS_SET_BULLETS,
    data,
  };
};

export const setDatapoint = (data) => {
  return {
    type: SETTINGS_SET_DATAPOINT,
    data,
  };
};

export const setDatapointAvg = (data) => {
  return {
    type: SETTINGS_SET_AVG_DATAPOINT,
    data,
  };
};

export const setSettingsAutomaticActions = (data) => {
  return {
    type: SETTINGS_SET_AUTOMATIC_ACTIONS,
    data,
  };
};

export const setModifiedSettings = (modifiedSettings) => {
  return async (dispatch, getState) => {
    dispatch({ type: SETTINGS_SET_MODIFIED_VALUES, data: modifiedSettings });
  };
};

export const setSettingsResponse = (response) => {
  return async (dispatch, getState) => {
    dispatch({ type: SETTINGS_SET_RESPONSE, data: response });
  };
};

export const updateTeamSettings = () => {
  return async (dispatch, getState) => {
    await dispatch(setSettingsLoading({ teamSettings: true }));
    try {
      const {
        modifiedSettings: { 
          teamColors, 
          homeTimeZone, 
          automaticOutlierApproval, 
          playersAppPermission, 
          preferredDateFormat,
          acwrLowerLimit,
          acwrUpperLimit,
          acwrAcuteWindow,
          acwrChronicWindow,
          topSpeedPercThreshold,
          chronicIncludesAcute
      }
      } = getState().settings;

      const response = await trainingAPI.updateTeamSettings({
        team_colors: teamColors, 
        home_timezone: homeTimeZone, 
        auto_outlier_approval: automaticOutlierApproval, 
        players_app_permission: playersAppPermission, 
        custom_date_format: preferredDateFormat,
        acwr_lower_limit: acwrLowerLimit,
        acwr_upper_limit: acwrUpperLimit,
        acwr_acute_window: acwrAcuteWindow,
        acwr_chronic_window: acwrChronicWindow,
        top_speed_threshold: topSpeedPercThreshold,
        chronic_includes_acute: chronicIncludesAcute
      });

      await dispatch(setSettingsResponse(response));
      
    } catch (e) {
      await dispatch(setSettingsResponse(false));
      console.error(e);
    }
    await dispatch(setSettingsLoading({ teamSettings: false }));
  };
};

export const getSettingsDataPoint = (
  type,
  date,
  selections,
  metric = undefined
) => {
  return async (dispatch) => {
    await dispatch(setSettingsLoading({ datapoint: true }));
    try {
      const { data, ...avg } = await trainingAPI.getSettingsDatapointAvg({
        data_type: type,
        selections,
        date,
        metric_id: metric?.metric_id,
      });
      await dispatch(setDatapoint(data));
      await dispatch(setDatapointAvg(avg));
    } catch (e) {
      console.error(e);
    }
    await dispatch(setSettingsLoading({ datapoint: false }));
  };
};


export const createSettingsDataPoint = (type, date, selections, inputs, metric) => {
  return async (dispatch) => {
    await dispatch(setDatapointPending({ create: true }));
    try {
      await trainingAPI.createSettingsDatapoint({
        type,
        date,
        selections,
        datapoint: inputs,
        metric_id: metric?.metric_id,
      });
      await dispatch(getSettingsDataPoint(type, date, selections, metric));
      message.success("Data point updated");
    } catch (e) {
      console.error(e);
    }
    await dispatch(setDatapointPending({ create: false }));
  };
};

export const deleteSettingsDataPoint = (type, date, selections, metric) => {
  return async (dispatch) => {
    await dispatch(setDatapointPending({ delete: true }));

    try {
      await trainingAPI.deleteSettingsDataPoint({
        date,
        data_type: type,
        selections,
        metric_id: metric?.metric_id,
      });
      await dispatch(getSettingsDataPoint(type, date, selections, metric));
      message.success("Data point deleted");
    } catch (e) {
      console.error(e);
    }
    await dispatch(setDatapointPending({ delete: false }));
  };
};

export const getSettingsAutomaticActions = () => {
  return async (dispatch) => {
    await dispatch(setSettingsLoading({ automatic: true }));
    try {
      const data = await trainingAPI.getSettingsAutomaticActions();
      await dispatch(setSettingsAutomaticActions(data));
    } catch (e) {}
    await dispatch(setSettingsLoading({ automatic: false }));
  };
};

export const updateSettingsAutomaticActions = (data) => {
  return async (dispatch) => {
    await dispatch(setDatapointPending({ automatic: true }));
    try {
      await trainingAPI.updateSettingsAutomaticActions(data);
      await dispatch(getSettingsAutomaticActions());
      message.success("Updated triggers");
    } catch (e) {
      console.error(e);
    }
    await dispatch(setDatapointPending({ automatic: false }));
  };
};

export const getBullets = () => {
  return async (dispatch) => {
    try {
      const data = await trainingAPI.getBullets();
      await dispatch(setBullets(data?.data));
    } catch (e) {
      console.error(e);
    }
  };
};

export const updateBullets = (bullets) => {
  return async (dispatch) => {
    await dispatch(setDatapointPending({ automatic: true }));
    try {
      const data = await trainingAPI.updateBullets(bullets);
      message.success("Changes have been saved successfully!");
    } catch (e) {
      message.error("Error occurred while saving changes");
      console.error(e);
    }
    await dispatch(setDatapointPending({ automatic: false }));
  };
};
